var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4697 4.96999C11.6105 4.83588 11.798 4.76173 11.9925 4.76321C12.187 4.76468 12.3733 4.84165 12.5121 4.97787C12.6509 5.1141 12.7314 5.29893 12.7366 5.49336C12.7417 5.68779 12.6711 5.87661 12.5397 6.01999L8.54967 11.01C8.48106 11.0839 8.39825 11.1432 8.3062 11.1844C8.21415 11.2255 8.11474 11.2477 8.01392 11.2496C7.9131 11.2514 7.81294 11.2329 7.71943 11.1952C7.62591 11.1575 7.54097 11.1013 7.46967 11.03L4.82367 8.38399C4.74998 8.31532 4.69088 8.23252 4.64989 8.14052C4.6089 8.04853 4.58685 7.94921 4.58508 7.84851C4.5833 7.74781 4.60183 7.64778 4.63955 7.55439C4.67727 7.461 4.73341 7.37617 4.80463 7.30495C4.87585 7.23373 4.96068 7.17758 5.05407 7.13986C5.14746 7.10214 5.24749 7.08362 5.34819 7.08539C5.44889 7.08717 5.54821 7.10921 5.64021 7.15021C5.73221 7.1912 5.81501 7.2503 5.88367 7.32399L7.97767 9.41699L11.4507 4.99199C11.4569 4.98429 11.4636 4.97694 11.4707 4.96999H11.4697Z",
    fill: "#F15B2B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListCheck);
export default __webpack_public_path__ + "static/media/list_check.6f49a2d29c3d32a5b7d164df6a46c966.svg";
export { ForwardRef as ReactComponent };